import { Loader } from "lucide-react";
import IconDownload from "@/assets/icons/download.svg?react";
import { cn } from "@/lib/utils";

interface DownloadIconProps {
  isLoading?: boolean;
  className?: string;
}

export const DownloadIcon: React.FC<DownloadIconProps> = ({
  isLoading = false,
  className,
}) => {
  if (isLoading) {
    return <Loader className={cn("animate-spin", className)} />;
  }

  return <IconDownload className={className} />;
};
